import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Icon from "@mui/material/Icon";
import ExpandMore from "@mui/icons-material/ExpandMore";
import ExpandLess from "@mui/icons-material/ExpandLess";

import MDBox from "../MDBox";
import { collapseItem, collapseIconBox, collapseIcon, collapseText } from "./styles/sidenavCollapse";

import { useMaterialUIController } from "../../Context/mui";
import { Collapse, List } from "@mui/material";
import { NavLink, useLocation } from "react-router-dom";
import { memo, useCallback } from "react";
import React from "react";

function Collapsechilds({ icon, name, active, childs, ...rest }: any) {
  const [controller] = useMaterialUIController();
  const { miniSidenav, transparentSidenav, whiteSidenav, darkMode, sidenavColor } = controller;
  const location = useLocation();
  const routeName = location.pathname.replace("/", "");

  const [open, setOpen] = React.useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [open]);
  return (
    <List sx={{ overFlow: "hidden" }}>
      <ListItem component="li" onClick={handleClick}>
        <MDBox
          {...rest}
          sx={(theme: any) =>
            collapseItem(theme, {
              active,
              transparentSidenav,
              whiteSidenav,
              darkMode,
              sidenavColor,
            })
          }
        >
          <ListItemIcon
            sx={(theme) =>
              collapseIconBox(theme, {
                transparentSidenav,
                whiteSidenav,
                darkMode,
                active,
              })
            }
          >
            {icon}
          </ListItemIcon>

          <ListItemText
            primary={name}
            sx={(theme) =>
              collapseText(theme, {
                miniSidenav,
                transparentSidenav,
                whiteSidenav,
                active,
              })
            }
          />
          {open ? <ExpandLess /> : <ExpandMore />}
        </MDBox>
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {childs.map((r: any) => {
          return (
            <NavLink to={r.route} key={r.key}>
              <ListItem>
                <MDBox
                  sx={[
                    (theme: any) =>
                      collapseItem(theme, {
                        sidenavColor,
                      }),
                    {
                      background: r.key === routeName ? "linear-gradient(195deg, #49a3f14a, #1a73e861)" : "",
                      marginLeft: "30px",
                    },
                  ]}
                >
                  <ListItem component="div">
                    <ListItemIcon sx={(theme) => collapseIconBox(theme, {})}>{r.icon}</ListItemIcon>

                    <ListItemText primary={r.name} sx={(theme) => collapseText(theme, {})} />
                  </ListItem>
                </MDBox>
              </ListItem>
            </NavLink>
          );
        })}
      </Collapse>
    </List>
  );
}

export default memo(Collapsechilds);
